<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Saldo'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-contract-balance-details-view *ngIf="!modify" [contractBalance]="contractBalance" (modifyClicked)="modify = true" (terminated)="loadContractBalance()"></app-contract-balance-details-view>
<!--    <app-contract-details-form *ngIf="modify" [contract]="contractBalance" (closeModification)="modify = false; loadContractBalance()"></app-contract-details-form>-->
  </mat-tab>
  <mat-tab label="Historia salda">
    <ng-template matTabContent>
      <app-contract-initial-balance-details-view [contractBalance]="contractBalance" ></app-contract-initial-balance-details-view>
    </ng-template>
  </mat-tab>
</mat-tab-group>
